import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSession } from "../hooks/useSession";

export default function Login() {
  const { data: me } = useSession();
  const navigate = useNavigate();

  useEffect(() => {
    if (!me) return;
    navigate(me.status === "APPROVED" ? "/" : "/pending-approval", { replace: true });
  }, [me, navigate]);

  return (
    <div className="flex h-full items-center justify-center bg-slate-100">
      <div className="w-full max-w-sm rounded-lg border border-slate-200 bg-white p-6 shadow-sm">
        <h1 className="mb-2 text-xl font-semibold text-slate-900">Claude AI Usage Monitor</h1>
        <p className="mb-6 text-sm text-slate-600">
          Sign in with your <span className="font-mono">@cloudlogiclimited.com</span> Google account.
        </p>
        <a
          href="/api/v1/auth/google/start"
          className="block w-full rounded bg-brand-700 px-4 py-2 text-center text-sm font-medium text-white hover:bg-brand-900"
        >
          Sign in with Google
        </a>
      </div>
    </div>
  );
}
